__webpack_require__.p = "https://coinlist.co/webpack";